import Header from "../components/header/header";
import Footer from "../components/footer";
import "../style/App.css";

export default function Userpage() {
  return (
    <div>
      <Header></Header>
      <h1 className="content">USER PAGE</h1>
      <Footer></Footer>
    </div>
  );
}
